// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".require-missing-profile-input .buttons{margin-bottom:10px}.require-missing-profile-input .buttons .btn{width:100%}", ""]);
// Exports
module.exports = exports;
